import React from "react";

/**
 * Текстовое поле DS (canon-session 2026-07-24): mono-label сверху,
 * focus → accent-рамка, error → danger-рамка + подпись.
 */
export function Input({
  label,
  error,
  numeric = false,
  bare = false,
  className = "",
  ...rest
}: React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  /** табличный моноширинный шрифт для числовых полей (num-display) */
  numeric?: boolean;
  /**
   * bare — чистый passthrough БЕЗ DS-стилей и label-обёртки: caller полностью
   * задаёт вид через className. Для компактных/inline-полей (settings-строки
   * `w-24 text-right`, `flex-1` рядом с кнопкой), где flex-col label-wrapper
   * сломал бы раскладку. Даёт единую точку входа (ui/Input) без визуального
   * сдвига. label/error в этом режиме не рендерятся.
   */
  bare?: boolean;
}) {
  if (bare) {
    return (
      <input
        {...rest}
        className={`${numeric ? "num-display tabular-nums " : ""}${className}`}
      />
    );
  }

  const borderCls = error
    ? "border-bad focus:border-bad"
    : "border-border focus:border-accent-hover";

  return (
    <label className="flex flex-col gap-1.5">
      {label && (
        <span className="font-mono text-[10.5px] tracking-[0.1em] uppercase text-text-tertiary">
          {label}
        </span>
      )}
      <input
        {...rest}
        className={`bg-bg-card text-text-primary border ${borderCls} rounded-xl px-3.5 py-[11px] text-sm outline-none transition-colors ${numeric ? "num-display tabular-nums" : ""} ${className}`}
      />
      {error && <span className="text-[11.5px] text-bad">{error}</span>}
    </label>
  );
}
